import React from "react";
import FallbackImage from '../FallbackImage/FallbackImage';

const OverlayCard = ({ title, subtitle, image }) => {
  return (
    <div className="relative group overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
      <div className="relative aspect-square overflow-hidden">
        <FallbackImage
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          placeholderText={title}
        />
        <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors duration-300"></div>
        
        <div className="absolute inset-0 flex items-center justify-center p-6">
          <div className="text-center text-white">
            <h3 className="text-xl font-bold mb-2">{title}</h3>
            <p className="text-sm opacity-90 leading-relaxed">{subtitle}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverlayCard;
